import {Directive, HostListener, HostBinding, Input, OnDestroy} from '@angular/core';
import {Router} from '../router';
import {RouteSegment} from '../segments';
import {isString, isArray, isPresent} from '../facade/lang';
import {ObservableWrapper} from '../facade/async';
import {LocationStrategy} from '@angular/common';
export class RouterLink implements OnDestroy { target: string;
  private _commands: any[] = [];
  private _subscription: any; href: string; isActive: boolean = false;

  constructor(private _routeSegment: RouteSegment, private _router: Router,
              private _locationStrategy: LocationStrategy) {
    // because auxiliary links take existing primary and auxiliary routes into account,
    // we need to update the link whenever params or other routes change.
    this._subscription =
        ObservableWrapper.subscribe(_router.changes, (_) => { this._updateTargetUrlAndHref(); });
  }

  ngOnDestroy() { ObservableWrapper.dispose(this._subscription); }
  set routerLink(data: any[] | any) {
    if (isArray(data)) {
      this._commands = <any[]>data;
    } else {
      this._commands = [data];
    }
    this._updateTargetUrlAndHref();
  }
  onClick(button: number, ctrlKey: boolean, metaKey: boolean): boolean {
    if (button != 0 || ctrlKey || metaKey) {
      return true;
    }

    if (isString(this.target) && this.target != '_self') {
      return true;
    }

    this._router.navigate(this._commands, this._routeSegment);
    return false;
  }

  private _updateTargetUrlAndHref(): void {
    let tree = this._router.createUrlTree(this._commands, this._routeSegment);
    if (isPresent(tree)) {
      this.href = this._locationStrategy.prepareExternalUrl(this._router.serializeUrl(tree));
      this.isActive = this._router.urlTree.contains(tree);
    } else {
      this.isActive = false;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[routerLink]'}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: RouteSegment, },
{type: Router, },
{type: LocationStrategy, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'target': [{ type: Input },],
'href': [{ type: HostBinding },],
'isActive': [{ type: HostBinding, args: ['class.router-link-active', ] },],
'routerLink': [{ type: Input },],
'onClick': [{ type: HostListener, args: ["click", ["$event.button", "$event.ctrlKey", "$event.metaKey"], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
